import { Stack, Typography } from "@mui/material";
import { MeetingListItemSkeleton } from "../../../../components";
import { TeamMeetingDto } from "../../../../http";
import { DateTime } from "luxon";
import { EditTeamMeetingModal, TeamMeetingListItem } from ".";
import { useState } from "react";

interface IProps {
  isLoading?: boolean;
  meetings: TeamMeetingDto[];
}

const TeamMeetingsList = (props: IProps) => {
  const [selectedMeetingGuid, setSelectedMeetingGuid] = useState<string | null>(null);
  function meetingSortFunction(a: TeamMeetingDto, b: TeamMeetingDto) {
    const aDate = a.lastInstanceDateTimeUtc ? DateTime.fromISO(a.lastInstanceDateTimeUtc) : null;
    const bDate = b.lastInstanceDateTimeUtc ? DateTime.fromISO(b.lastInstanceDateTimeUtc) : null;

    if (aDate == null && bDate == null) {
      return 0;
    }
    if (aDate == null) {
      return 1;
    }
    if (bDate == null) {
      return -1;
    }

    return bDate < aDate ? -1 : 1;
  }

  return (
    <>
      <Stack spacing={1}>
        {props.isLoading ? (
          <MeetingListItemSkeleton />
        ) : props.meetings.length <= 0 ? (
          <Typography sx={{ m: 1 }}>Nothing here yet.</Typography>
        ) : (
          props.meetings
            .sort(meetingSortFunction)
            .map((meeting) => (
              <TeamMeetingListItem
                key={meeting.guid}
                meeting={meeting}
                onSettingsClicked={(meetingGuid) => setSelectedMeetingGuid(meetingGuid)}
              />
            ))
        )}
      </Stack>
      {selectedMeetingGuid && (
        <EditTeamMeetingModal
          visible
          meetingGuid={selectedMeetingGuid}
          onSaved={() => {
            setSelectedMeetingGuid(null);
          }}
          onCancelled={() => {
            setSelectedMeetingGuid(null);
          }}
        />
      )}
    </>
  );
};

export { TeamMeetingsList };
